import { useMemo, useRef } from 'react';
import { Modal } from '@/components';
import { useNavigate } from 'react-router';
import { NavigationPath } from '@/router/navigation-path';
import { useSolveQuestion } from '@/context/solve-question-context';
import 'react-image-crop/src/ReactCrop.scss';
import { ImageCropTool } from '@/components/image-crop-tool';

export const ImageCropModal = () => {
	const navigate = useNavigate();
	const { isOpenImageCropModal, setIsOpenImageCropModal, getActiveQuestion, isResolveMode, resolveQueueId } = useSolveQuestion();
	const activeQuestion = useMemo(() => getActiveQuestion(), [getActiveQuestion]);

	const cropToolRef = useRef<{ generateCroppedImage: () => string | null }>(null);

	const onContinueWithoutCrop = () => {
		setIsOpenImageCropModal(false);

		navigate(NavigationPath.solverWhiteBoard, {
			state: {
				interactionId: activeQuestion?.interactionId,
				activeQuestion,
				isResolveMode,
				resolveQueueId
			}
		});
	};

	const onContinueWithCrop = () => {
		const croppedData = cropToolRef.current?.generateCroppedImage();

		if (!croppedData) {
			console.warn('Kırpılmış görsel oluşturulamadı');
			return;
		}

		setIsOpenImageCropModal(false);
		navigate(NavigationPath.solverWhiteBoard, {
			state: {
				interactionId: activeQuestion?.interactionId,
				activeQuestion: {
					...activeQuestion,
					questionImage: croppedData
				},
				isResolveMode,
				resolveQueueId
			}
		});
	};

	return (
		<Modal
			isOpen={isOpenImageCropModal}
			onClose={() => setIsOpenImageCropModal(false)}
			contentClassName="image-crop-modal"
			showCloseButton
			size="lg"
			closeOnClickOutside={false}
			variant="centered"
			customXIcon={<i className="icons-x" />}>
			<div className="wrapper">
				<h6 className="wrapper-title">Fotoğrafı Kırp</h6>
				<div className="description-wrapper">
					<i className="icons-info-circle" />
					<p>Lütfen soru fotoğrafını düz, anlaşılır ve sadece soru ile ilgili bilgileri içerecek şekilde kırpınız.</p>
				</div>

				<ImageCropTool
					ref={cropToolRef}
					src={activeQuestion?.questionImage || ''}
				/>
			</div>

			<div className="button-wrapper">
				<button
					onClick={onContinueWithoutCrop}
					className="start-solve-button light">
					Kırpmadan Devam Et
				</button>

				<button
					onClick={onContinueWithCrop}
					className="start-solve-button">
					Seçili Alanı Kırp
				</button>
			</div>
		</Modal>
	);
};
